// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cPCV","type":"styles_type__1rZSM","choices":"styles_choices__3F5TD"};